import { Routes } from '@angular/router';
import { OrgType } from './core/authentication/user-org-types.enum';
import { authGuardFn } from './core/guards/auth.guard';
import { orgTypeGuardFn } from './core/guards/org-type.guard';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { ClientLayoutComponent } from './layout/client-layout/client-layout.component';
import { operatorIdResolverFn } from './layout/operator-id.resolver';
import { UnauthorizedComponent } from './layout/unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    component: ClientLayoutComponent,
    loadChildren: () => import('./client/client.routes').then((m) => m.CLIENT_ROUTES),
    canActivate: [authGuardFn, orgTypeGuardFn],
    resolve: { operatorId: operatorIdResolverFn },
    data: {
      expectedOrgTypes: [OrgType.Operators],
    },
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    canActivate: [authGuardFn, orgTypeGuardFn],
    data: {
      expectedOrgTypes: [OrgType.Admin],
    },
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.routes').then((m) => m.LOGIN_ROUTES),
  },
  {
    path: 'mahle/login',
    loadChildren: () => import('./mahle-login/mahle-login.routes').then((m) => m.MAHLE_LOGIN_ROUTES),
  },
  {
    path: 'avebe/login',
    loadChildren: () => import('./avebe-login/avebe-login.routes').then((m) => m.AVEBE_LOGIN_ROUTES),
  },
  {
    path: 'bayer/login',
    loadChildren: () => import('./bayer-login/bayer-login.routes').then((m) => m.BAYER_LOGIN_ROUTES),
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
];
